import { Model } from '@vuex-orm/core'
import Lesson from '@/modules/lesson/models/Lesson'

export default class UserLesson extends Model {
  static entity = 'userLessons'

  static fields() {
    return {
      id: this.string(''),
      entity_type: this.attr(null),
      entity_id: this.attr(null),
      custom_class_id: this.attr(null),
      current_slide: this.attr(),
      is_completed: this.attr(false),
      completed_at: this.attr(false),
      created_at: this.string(''),
      updated_at: this.string(''),
      lesson_id: this.attr(null),
      lesson: this.belongsTo(Lesson, 'lesson_id'),
      user_lesson_slides: this.attr(null),
      post_quiz: this.number(0),
      pre_quiz: this.number(0)
    }
  }
}
